import React, { useEffect, useState } from 'react';
import { Table, Input, Tag, Space, Avatar, Typography, Select, Button, DatePicker } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import request from '../utils/request';

const { RangePicker } = DatePicker;

const { Text } = Typography;

const fmtTime = (v?: string) => (v ? new Date(v).toLocaleString('zh-CN', { hour12: false }) : '-');

// 分销绑定关系：展示分销员与客户之间的绑定记录及有效状态
const Referrals: React.FC = () => {
  const [list, setList] = useState<any[]>([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [keyword, setKeyword] = useState('');
  const [loading, setLoading] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [active, setActive] = useState<string | undefined>();
  const [range, setRange] = useState<any>(null);

  const fetchList = async (p = page, kw = keyword) => {
    setLoading(true);
    try {
      const res: any = await request.get('/distribution/admin/referrals', {
        params: {
          page: p,
          pageSize,
          keyword: kw || undefined,
          active,
          startDate: range?.[0]?.format('YYYY-MM-DD'),
          endDate: range?.[1]?.format('YYYY-MM-DD'),
        },
      });
      setList(res.list);
      setTotal(res.total);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchList(); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [page, active, range, pageSize]);

  const resetFilters = () => {
    setKeyword(''); setActive(undefined); setRange(null); setPage(1);
    fetchList(1, '');
  };

  const userCell = (u: any) => (
    u ? (
      <Space size={4}>
        <Avatar size="small" icon={<UserOutlined />} />
        <span>{u.realName || u.nickname || `#${u.id}`}</span>
        {u.phone && <Text type="secondary">({u.phone})</Text>}
      </Space>
    ) : '-'
  );

  const columns = [
    { title: 'ID', dataIndex: 'id', width: 60 },
    { title: '分销员', width: 200, render: (_: any, r: any) => userCell(r.referrer) },
    { title: '客户', width: 200, render: (_: any, r: any) => userCell(r.user) },
    {
      title: '绑定商品', dataIndex: 'productId', width: 100,
      render: (v: number) => (v ? `#${v}` : <Text type="secondary">通用</Text>),
    },
    { title: '最近绑定', dataIndex: 'lastBindAt', width: 160, render: (v: string) => fmtTime(v) },
    { title: '到期时间', dataIndex: 'expireAt', width: 160, render: (v: string) => fmtTime(v) },
    {
      title: '状态', dataIndex: 'isActive', width: 90,
      render: (v: boolean) => (v ? <Tag color="green">有效</Tag> : <Tag>已过期</Tag>),
    },
  ];

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
        <h2 style={{ margin: 0 }}>分销关系</h2>
        <Space>
          <Input.Search
            allowClear
            placeholder="搜索分销员/客户 昵称或手机号"
            style={{ width: 260 }}
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            onSearch={(v) => { setPage(1); fetchList(1, v.trim()); }}
          />
          <RangePicker
            placeholder={['绑定起', '绑定止']}
            onChange={(v) => { setPage(1); setRange(v); }}
          />
          <Select allowClear placeholder="有效状态" style={{ width: 120 }} value={active}
            onChange={(v) => { setPage(1); setActive(v); }}
            options={[
              { label: '有效', value: '1' },
              { label: '已过期', value: '0' },
            ]} />
          {(keyword || range || active) && <Button onClick={resetFilters}>重置</Button>}
        </Space>
      </div>
      <Table columns={columns} dataSource={list} rowKey="id" loading={loading} scroll={{ x: 1000 }}
        pagination={{
          current: page, total, pageSize, showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50', '100'],
          onChange: (p, ps) => { setPage(p); setPageSize(ps); },
        }} />
    </div>
  );
};

export default Referrals;
